import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FaBars } from 'react-icons/fa'
import LanguageSelector from './LanguageSelector'
import useTranslation from '../hooks/useTranslation'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  // Determine if we're on mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && isMobile) {
        const nav = document.querySelector('nav');
        const menuIcon = document.querySelector('.mobile-menu-icon');
        
        // If click is outside nav and not on menu icon, close menu
        if (nav && !nav.contains(event.target) && !menuIcon.contains(event.target)) {
          setIsMenuOpen(false);
        }
      }
    };

    // Add event listener
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen, isMobile]);

  return (
    <header style={{
      padding: scrolled ? '15px 0' : (isMobile ? '15px 0' : '20px 0'),
      zIndex: 100 // Lower than event banner (101)
    }}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">AYITE</Link>

          {/* Language Selector - Only visible on desktop */}
          {!isMobile && (
            <div className="language-selector-container">
              <LanguageSelector />
            </div>
          )}

          <div className="mobile-menu-icon" onClick={toggleMenu} style={{
            display: 'none',
            '@media (max-width: 768px)': {
              display: 'block'
            }
          }}>
            <FaBars style={{ fontSize: '24px' }} />
          </div>
          <nav className={isMenuOpen ? 'active' : ''}>
            <div className="mobile-menu-content">
              <ul>
                <li><Link to="/" onClick={() => setIsMenuOpen(false)}>{t('nav.home')}</Link></li>
                <li><Link to="/bio" onClick={() => setIsMenuOpen(false)}>{t('nav.bio')}</Link></li>
                <li><Link to="/shows" onClick={() => setIsMenuOpen(false)}>{t('nav.shows')}</Link></li>
                <li><Link to="/video" onClick={() => setIsMenuOpen(false)}>{t('nav.video')}</Link></li>
                <li><Link to="/gallery" onClick={() => setIsMenuOpen(false)}>{t('nav.gallery')}</Link></li>
                <li><Link to="/social" onClick={() => setIsMenuOpen(false)}>{t('nav.social')}</Link></li>
                <li><Link to="/booking" onClick={() => setIsMenuOpen(false)}>{t('nav.booking')}</Link></li>
              </ul>

              {/* Mobile Language Selector - Always at the bottom */}
              {isMobile && (
                <div className="mobile-language-selector">
                  <LanguageSelector />
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
